<is-wait-message [loadComplete]="loadComplete() && !submitCallInProgress()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0">
</is-wait-message>

@if (loadComplete()) {
  <form [formGroup]="formGroup.group" class="form-group manage-payment-form-container">
    <div class="bolt-container bolt-space-bottom-2xl">
      <bolt-progress-bar appFocusOnInit arialabel="cancel automatic payments progress value is 50%" value="50" class="progress-bar-container to-container"></bolt-progress-bar>
      <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Cancel automatic payments</h1>
      @if (globalErrorDisplayable) {
        <div class="bolt-space-bottom-2xl" [id]="'global-error-message'">
          <bolt-notification class="to-container" type="error" id="#global-error-message">Please check the information below and try again.</bolt-notification>
        </div>
      }
      <h2 class="bolt-heading-sm bolt-space-bottom-xl">Confirm your choice</h2>
      <section id="payment-method-section" class="fluid-container">
        <app-are-you-sure-radio-buttons formGroupName="areYouSureFormGroup" [submitted]="submitted" [displayMessage]="displayMessageForForm"></app-are-you-sure-radio-buttons>
        @if (displayDueDate) {
          <bolt-notification type="info" class="to-container bolt-space-bottom-2xl">{{dueAlertMessage}}</bolt-notification>
        }
        <bolt-notification class="to-container bolt-space-bottom-2xl" type="info">{{warningMessage}}</bolt-notification>
      </section>
    </div>
    <bolt-button-bar>
      <bolt-button slot="cancel" id="cancel-button" (click)="cancelAutomaticPayment()">Cancel</bolt-button>
      <bolt-button submit type="solid" slot="forward" id="submit-button" (click)="submit()">
      Submit</bolt-button>
    </bolt-button-bar>
  </form>
}